import { FaBed, FaBath, FaMapMarkerAlt } from "react-icons/fa";
import { BiExpand } from "react-icons/bi";
import { getStatusClasses } from "../../utils/propertyStatusColors";
import CardImageCarousel from "./CardImageCarousel";

const House = ({ house }) => {
  const isSoldOrRented =
    house.state === "Vendido" || house.state === "Alquilado";

  return (
    <div className="w-full h-full flex flex-col rounded-xl overflow-hidden shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300 bg-white group">
      {/* Imagen con overlay gradient */}
      <div className="relative overflow-hidden">
        <CardImageCarousel images={house.images} alt={house.name} />
        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent pointer-events-none" />

        {/* Badge de estado (solo si está disponible) */}
        {!isSoldOrRented && (
          <span
            className={`absolute top-3 right-3 text-xs font-semibold px-3 py-1 rounded-full z-10 ${getStatusClasses(house.state)}`}
          >
            {house.state}
          </span>
        )}

        {/* Sello diagonal para vendidas / alquiladas */}
        {isSoldOrRented && (
          <div className="absolute inset-0 z-20 flex items-center justify-center overflow-hidden pointer-events-none">
            <div className="w-[160%] -rotate-[18deg] bg-logoRed/95 py-2.5 shadow-lg">
              <p className="text-center text-white text-2xl font-extrabold uppercase tracking-[0.3em] drop-shadow">
                {house.state}
              </p>
            </div>
          </div>
        )}
      </div>

      {/* Contenido */}
      <div className={`flex-1 flex flex-col ${isSoldOrRented ? "opacity-60" : ""}`}>
        <div className="px-5 pt-4 pb-2">
          {/* Dirección con icono de ubicación */}
          <div className="flex items-center gap-1.5 mb-2">
            <FaMapMarkerAlt className="w-3.5 h-3.5 text-primary flex-shrink-0" />
            <h2 className="text-lg font-bold text-gray-800 truncate">
              {house.address}
            </h2>
          </div>

          {/* Badges de tipo y localidad */}
          <div className="flex items-center gap-2 mb-3">
            <span className="text-xs font-medium px-2.5 py-0.5 rounded-full bg-gray-100 text-gray-600">
              {house.type}
            </span>
            <span className="text-xs font-medium px-2.5 py-0.5 rounded-full bg-gray-100 text-gray-600">
              {house.country}
            </span>
          </div>

          {/* Características con react-icons */}
          <div className="flex items-center gap-4 text-sm text-gray-600">
            {house.characteristics.dormitorios > 0 && (
              <div className="flex items-center gap-1.5">
                <FaBed className="w-4 h-4 text-gray-400" />
                <span className="font-medium">
                  {house.characteristics.dormitorios}{" "}
                  {house.characteristics.dormitorios > 1 ? "Cuartos" : "Cuarto"}
                </span>
              </div>
            )}

            {house.characteristics.baños > 0 && (
              <div className="flex items-center gap-1.5">
                <FaBath className="w-4 h-4 text-gray-400" />
                <span className="font-medium">
                  {house.characteristics.baños}{" "}
                  {house.characteristics.baños > 1 ? "Baños" : "Baño"}
                </span>
              </div>
            )}

            {house.surface !== undefined && house.surface !== "" && (
              <div className="flex items-center gap-1.5">
                <BiExpand className="w-4 h-4 text-gray-400" />
                <span className="font-medium">{house.surface}</span>
              </div>
            )}
          </div>
        </div>

        {/* Separador + Precio */}
        <div className="border-t border-gray-100 mx-5 mt-auto" />
        <div className="px-5 py-3">
          {!isSoldOrRented && house.state && (
            <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 mb-0.5">
              {house.state === "Alquiler"
                ? "En alquiler"
                : house.state === "Venta"
                ? "En venta"
                : house.state}
            </p>
          )}
          <p className="text-2xl font-extrabold text-primary">
            {isSoldOrRented ? (
              house.state
            ) : house.currency && house.price ? (
              <>
                <span className="text-sm font-semibold text-gray-500 mr-1">
                  {house.currency}
                </span>
                {Number(house.price).toLocaleString("es-AR")}
              </>
            ) : (
              "Consultar"
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default House;
